function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#767E9D",
  fillRule: "evenodd",
  d: "M6,5 L13,5 L13,3 L6,3 L6,5 Z M6,9 L13,9 L13,7 L6,7 L6,9 Z M6,13 L13,13 L13,11 L6,11 L6,13 Z M3,5 L5,5 L5,3 L3,3 L3,5 Z M3,9 L5,9 L5,7 L3,7 L3,9 Z M3,13 L5,13 L5,11 L3,11 L3,13 Z M14.4,0 L1.6,0 C0.7168,0 0,0.7168 0,1.6 L0,14.4 C0,15.2816 0.7168,16 1.6,16 L14.4,16 C15.2824,16 16,15.2816 16,14.4 L16,1.6 C16,0.7168 15.2824,0 14.4,0 L14.4,0 Z"
});

var SvgListFilled16 = function SvgListFilled16(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgListFilled16, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ListFilled16.0c4b6bf1.svg";
export { ForwardRef as ReactComponent };